function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("defs", null,
/*#__PURE__*/
React.createElement("style", null, ".a{opacity:.1}.b{fill:none;stroke:#000;stroke-linecap:round;stroke-linejoin:round;stroke-width:3px}"));

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  d: "M13.606 20H1.118A1.134 1.134 0 010 18.852V17.54a.492.492 0 01.248-.427l6.885-3.934a.492.492 0 01.488.854L.984 17.825v1.027a.155.155 0 00.135.164h12.488a.492.492 0 010 .984zM14.262 14.755a.488.488 0 01-.182-.035l-1.642-.656a.492.492 0 11.365-.913l1.642.656a.492.492 0 01-.182.949z"
});

var _ref4 =
/*#__PURE__*/
React.createElement("path", {
  d: "M7.377 14.1a.488.488 0 01-.312-.112c-2.621-2.16-2.508-5.868-2.5-6.024V4.24a.507.507 0 01.007-.081C4.984 1.689 7.666.024 9.931.004h.042c2.274 0 4.988 1.67 5.4 4.155a.513.513 0 01.007.081v3.743c.008.131.177 3.844-2.449 6.008a.492.492 0 11-.626-.759c2.246-1.851 2.093-5.188 2.091-5.221V4.284c-.348-1.93-2.572-3.276-4.387-3.295h-.037c-1.821 0-4.073 1.351-4.424 3.3v3.7c0 .051-.095 3.4 2.145 5.246a.492.492 0 01-.313.871z"
});

var _ref5 =
/*#__PURE__*/
React.createElement("g", null,
/*#__PURE__*/
React.createElement("path", {
  d: "M16.886 19.999a.492.492 0 01-.492-.492v-5.246a.492.492 0 11.984 0v5.246a.492.492 0 01-.492.492z"
}),
/*#__PURE__*/
React.createElement("path", {
  d: "M19.509 17.377h-5.246a.492.492 0 110-.984h5.246a.492.492 0 110 .984z"
}));

var SvgAddClient = function SvgAddClient(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return (
    /*#__PURE__*/
    React.createElement("svg", _extends({
      viewBox: "0 0 20 20",
      ref: svgRef
    }, props), title ?
    /*#__PURE__*/
    React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5)
  );
};

var ForwardRef =
/*#__PURE__*/
React.forwardRef(function (props, ref) {
  return (
    /*#__PURE__*/
    React.createElement(SvgAddClient, _extends({
      svgRef: ref
    }, props))
  );
});
export default __webpack_public_path__ + "static/media/addClient.536ed811.svg";
export { ForwardRef as ReactComponent };